import { useTranslation } from 'react-i18next'

/**
 * Backend-authored content arrives in both languages at once (`title_ru` /
 * `title_en`). It bypasses i18next — the copy is data, not interface — but the
 * choice still follows the interface language. The hook subscribes through
 * `useTranslation`, so a language switch re-renders the caller.
 */
export function usePickLocalized() {
  const { i18n } = useTranslation()

  return (ru: string, en: string): string => (i18n.language.startsWith('ru') ? ru : en)
}
